<template>
  <div :class="[
    (nested ? `p-6 bg-gray-${level * 100 + 100} border-gray-200` : `bg-white border-b border-gray-200 text-left max-w-full rounded-lg ${shadow}`),

  ]">
    <!-- Projects table (small breakpoint and up) -->
    <div :class="[
      (nested ? `border overflow-visible ${shadow}` : 'border-b'),
      'rounded-lg align-middle inline-block w-full border-gray-200',
      (scroll && !nested ? 'overflow-auto max-h-[85vh]' : ''),
    ]" @scroll="scrolled" ref="tablecontainer">
      <table :class="[tableCss, 'w-full max-w-full', (sortable ? 'base-table--sortable' : '')]" @mousemove="move" @mousedown="startDragging" @mouseup="stopDragging" @mouseleave="stopDragging">
        <thead v-if="$slots.head" :class="['sticky top-0 z-60 bg-gray-50']">
          <tr :class="['bg-gray-50', (nested ? 'border-b' : 'border-t border-b border-gray-200')]">
            <slot name="head" />
          </tr>
        </thead>
        <tbody :class="['bg-white divide-y divide-gray-100']">
          <slot />
        </tbody>
        <tfoot v-if="$slots.foot" class="bg-gray-50 border-t border-gray-200">
          <tr>
            <slot name="foot" />
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
<script>
import TableCell from './TableCell';
export default {
  name: 'BaseTable',
  components: {
    TableCell,
  },
  props: {
    nested: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 1,
    },
    tableCss: {
      type: String,
      default: '',
    },
    scroll: {
      type: Boolean,
      default: false,
    },
    // Enable draggable
    sortable: {
      type: Boolean,
      default: false,
    },
    // v-model for draggable
    value: {
      type: Array,
      default: () => [],
    },
    shadow: {
      type: String,
      default: 'shadow'
    },
  },
  computed: {
    items: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  data() {
    return {
      mouseDown: false,
      mouseStartX: null,
      mouseScrollLeft: 0,
    };
  },
  methods: {
    scrolled(event) {
      if (this.scroll) {
        this.$emit('scrolled', event);
      }
    },
    move(evt) {
      evt.preventDefault();
      if(!this.mouseDown) { return; }

      const x = evt.pageX - this.$refs.tablecontainer.offsetLeft;
      console.log(x);
      const scroll = x - this.mouseStartX;
      console.log(scroll);
      this.$refs.tablecontainer.scrollLeft = this.mouseScrollLeft - scroll;
      console.log(this.$refs.tablecontainer.scrollLeft);
      // console.log([scroll, this.mouseScrollLeft, this.mouseStartX]);
    },
    startDragging(evt) {
      this.mouseDown = true;
      this.mouseStartX = evt.pageX - this.$refs.tablecontainer.offsetLeft;
      this.mouseScrollLeft = this.$refs.tablecontainer.scrollLeft;
    },
    stopDragging(evt) {
      this.mouseDown = false;
    },
  },
  mounted() {
    window.$GD = this;
  }
};
</script>
<style>
/* .base-table--sortable tr::before {
  content: ' ';
  display: table-cell;
  opacity: 0.9;
  vertical-align: middle;
  width: 50px;
}
.base-table--sortable tbody tr {
  cursor: move;
}
.base-table--sortable tbody tr::before {
  background-image: url("https://cdn.jsdelivr.net/npm/heroicons@1.0.0/solid/switch-vertical.svg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 33% auto;
} */
</style>
